import { useState } from 'react';
import axios from 'axios';
import api from '../utils/api';

export const useAvatarUpload = () => {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);

  const handleUpload = async ({ file, userId, onSuccess, onFailure }) => {
    setUploading(true);
    setError(null);

    try {
      // 1️⃣ Get pre-signed URL
      const signedRes = await api.post('/api/generate-upload-url', {
        fileName: file.name,
        fileType: file.type,
      });

      const signedUrl = signedRes.data?.signedUrl; // ✅ matches backend response


      const key = signedRes.data?.key;

      if (!signedUrl || !key) throw new Error("Missing signed URL or key");

      // 2️⃣ Upload file to S3
      await axios.put(signedUrl, file, {
        headers: { 'Content-Type': file.type },
      });

      // 3️⃣ Generate public URL
      const uploadedImageUrl = signedUrl.split('?')[0];

      // 4️⃣ Update backend user profile
      const updateRes = await api.post('/api/profile/update-avatar', {
        userId,
        avatarUrl: uploadedImageUrl,
      });

      onSuccess?.(uploadedImageUrl, updateRes.data);
    } catch (err) {
      console.error("❌ Avatar upload failed:", err);
      setError(err);
      onFailure?.(err);
    } finally {
      setUploading(false);
    }
  };

  return { uploading, error, handleUpload };
};